import React, { Component } from 'react'
import styled from 'styled-components'
import SwiperCore, { Scrollbar, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import theme from 'ui/styles/theme'
import easing from 'ui/styles/easing'

import IconApple from './IconApple'
import IconGoogle from './IconGoogle'

SwiperCore.use([Scrollbar, Navigation])

export default class TryBeforeYouBuy extends Component {
  render() {
    const { steps } = this.props
    
    return (
      <Wrapper>
        <Container fluid>
          <Row>
            <Col>
              <Swiper
                spaceBetween={20}
                slidesPerView={1}
                scrollbar
                navigation
                breakpoints={{
                  690: {
                    slidesPerView: 2
                  },
                  1024: {
                    slidesPerView: 3
                  }
                }}
              >
                {steps.map((step, index) => (
                  <SwiperSlide>
                    <Step>
                      <Number>{index + 1 < 10 ? `0${index + 1}` : index + 1}</Number>
                      <h2>{step.title}</h2>
                      
                      <Mid>
                        {step.type === 'image' && step.image && (
                          <img src={step.image.sourceUrl} alt="" />
                        )}

                        {step.type === 'download' && (
                          <Downloads>
                            {step.appleLink && (
                              <Download href={step.appleLink} target="_blank">
                                <span>Download app</span>
                                <IconApple />
                              </Download>
                            )}

                            {step.googleLink && (
                              <Download href={step.googleLink} target="_blank">
                                <span>Download app</span>
                                <IconGoogle />
                              </Download>
                            )}
                          </Downloads>
                        )}
                      </Mid>

                      <h4>{step.subTitle}</h4>
                      <p>{step.text}</p>

                    </Step>
                  </SwiperSlide>

                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </Wrapper>
    )
  }
}

// Styles
const { colors } = theme

const Wrapper = styled.section`
  background: ${colors.tones.lightest};
  padding: 2.5rem 0 4rem;
  overflow: hidden;

  .swiper-container {
    padding-bottom: 2.5rem;
    overflow: visible;
  }

  .swiper-slide {
    height: auto;
  }

  .swiper-button-prev,
  .swiper-button-next {
    width: 2.5rem;
    height: 2.5rem;
    background: ${colors.primary};
    border-radius: 100%;
    transition: opacity 0.3s ${easing.easeOutCubic};

    &:after {
      font-size: 1rem;
      color: white;
    }

    &.swiper-button-disabled {
      opacity: 0;
    }

    ${media.xs`
      display: none;
    `}
  }

  .swiper-button-prev {
    left: -5px;
    transform: translateX(-100%);
  }

  .swiper-button-next {
    right: -5px;
    transform: translateX(100%);
  }


  
  .swiper-container-horizontal>.swiper-scrollbar {
    width: 100%;
    left: 0;
    height: 2px;
    background: ${colors.tones.lighter};

    .swiper-scrollbar-drag {
      background: ${colors.primary};
    }
  }

`

const Step = styled.div`
  background: ${colors.tones.lighter};
  padding: 1.5rem;
  border-radius: 0.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;

  h2 {
    font-size: 1rem;
    line-height: normal;
  }

  h4 {
    font-size: 0.8rem;
    text-transform: uppercase;
    font-weight: 500;
  }

  p {
    font-weight: 300;
    font-size: 1rem;
  }

  img {
    width: 100%;
  }
`

const Number = styled.span`
  font-size: 3rem;
  font-weight: 300;
  color: ${colors.primary};
`

const Mid = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
`

const Downloads = styled.div`
  width: 100%;
`

const Download = styled.a`
  width: 100%;
  display: block;
  background: ${colors.tones.lightest};
  padding: 1.5rem;
  border-radius: 1rem;
  margin-bottom: 1rem;
  color: ${colors.tones.darker};
  text-transform: uppercase;
  font-size: 0.8rem;
  
  svg {
    margin: 1.5rem auto 2rem;
    width: auto;
  }
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/TryBeforeYouBuy/index.js